import type { ShoppingItem } from '@/entities/shopping-item/schemas/shopping-item';
import { parseNumber } from '@/shared/components/form/parse-number';
import { parseEuros } from '@/shared/lib/money/parse-euros';
import type { ShoppingFormValues } from '../schemas/shopping-form-values';

export function fromShoppingForm(values: ShoppingFormValues, base?: ShoppingItem): Partial<ShoppingItem> {
  return {
    ...base,
    name: values.name,
    category: values.category,
    quantity: parseNumber(values.quantity) ?? 1,
    unit: values.unit || 'ud',
    estimated_price_cents: parseEuros(values.estimate),
    priority: values.priority,
    needed_by: values.needed_by,
    store: values.store,
    url: values.url,
    notes: values.notes,
  };
}
